import {getHistory} from '../externals/wc-navigation';
import {getPath} from "../helpers/utils";

const Component = () => {
  return (
    <>
      <h1>Test</h1>
      <p>hahaha</p>
    </>
  );
}

const AppRouter = () => {

  console.log(getHistory());

  // render upsell in wc admin analytics page.
  if ('/analytics/coupons' === getPath()) {
    return <Component />
  }

  return null;
}

export default AppRouter;